import React, { Component } from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from '../components/confirmDialog';
import * as webViewerServersActions from '../store/webViewerServersSlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import { showModalMessage } from '../store/modalsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

class DeactivateWebViewerServerConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
    this.deactivateHandler = null;
  }

  onConfirm() {
    const { serverId } = this.props;
    this.props.deactivateWebViewerServer({ webViewerServerId: serverId })
      .then(unwrapResult)
      .catch(() => {
        this.props.showModalMessage("Error", this.props.error.toString());
      });
    this.props.onClose();
  }

  render() {
    return (
      <ConfirmDialog
        show={this.props.show}
        onClose={this.props.onClose}
        title="Web viewer server deactivating"
        question="Are you sure want to deactivate selected web viewer server?"
        onConfirm={this.onConfirm}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  error: webViewerServersSelectors.state(state).creatingUpdatingError,
});

const actionCreators = {
  deactivateWebViewerServer: webViewerServersActions.deactivate,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
}

export default connect(mapStateToProps, actionCreators)(DeactivateWebViewerServerConfirmDialog);


// WEBPACK FOOTER //
// ./src/containers/deactivateWebViewerServerConfirmDialog.js